export const SPECS = {
  ShouldAddSpecificItemDiscountsForCashierValidation: 'specs.stores.ShouldAddSpecificItemDiscountsForCashierValidation',
  SupportDelayedCaptureOnCheckoutAndExpressButtons: 'specs.stores.SupportDelayedCaptureOnCheckoutAndExpressButtons',
  ShouldUpdateInstanceOnInstanceChange: 'specs.stores.ShouldUpdateInstanceOnInstanceChange',
  SendFullAddressOnExpressButtons: 'specs.stores.SendFullAddressOnExpressButtons'
};
//# sourceMappingURL=SPECS.js.map